/*
 * collection-show-more.js
 * Incarcare progresiva a produselor pe pagina de colectie:
 *  - buton "Arata mai multe" (click) + infinite scroll (auto-load cand butonul
 *    intra in viewport, prin IntersectionObserver).
 *  - fetch la URL-ul paginii urmatoare (pastreaza filtrele/sortarea din paginate),
 *    parseaza HTML-ul si adauga doar .grid__item in grid.
 *  - fallback fara JS: butonul este un <a href> real spre pagina urmatoare +
 *    <noscript> cu paginarea clasica.
 * Defensiv: totul guarded, nu arunca erori daca lipsesc elemente/app-uri.
 */
(function () {
  "use strict";

  function init() {
    var wrapper = document.querySelector("[data-show-more]");
    var grid = document.querySelector("[data-product-grid]");
    if (!wrapper || !grid) return;

    var loading = false;
    var observer = null;

    function getBtn() {
      return wrapper.querySelector("[data-show-more-btn]");
    }

    function setLoading(state) {
      loading = state;
      var spinner = wrapper.querySelector("[data-show-more-spinner]");
      var btn = getBtn();
      if (spinner) spinner.hidden = !state;
      if (btn) btn.style.visibility = state ? "hidden" : "";
    }

    function stop() {
      if (observer) observer.disconnect();
      var btn = getBtn();
      if (btn && btn.parentNode) btn.parentNode.removeChild(btn);
    }

    function refreshWishlist() {
      // iWish (app extern) leaga click-urile doar la load; itemele noi sunt
      // tratate prin delegarea de mai jos. Aici doar improspatam starile/contorul.
      try {
        if (typeof window.iWishinit === "function") window.iWishinit();
      } catch (e) {}
    }

    function loadNext() {
      if (loading) return;
      var btn = getBtn();
      if (!btn) return;
      var url = btn.getAttribute("href");
      if (!url) return;

      setLoading(true);

      fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } })
        .then(function (res) {
          if (!res.ok) throw new Error("HTTP " + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var nextGrid = doc.querySelector("[data-product-grid]");
          var items = nextGrid
            ? nextGrid.querySelectorAll(".grid__item")
            : [];

          if (items.length) {
            var frag = document.createDocumentFragment();
            Array.prototype.forEach.call(items, function (item) {
              item.setAttribute("data-more-loaded", "");
              frag.appendChild(item);
            });
            grid.appendChild(frag);
          }

          // actualizeaza butonul cu linkul paginii urmatoare (daca mai exista)
          var nextBtn = doc.querySelector("[data-show-more-btn]");
          var nextUrl = nextBtn && nextBtn.getAttribute("href");
          if (nextUrl) {
            btn.setAttribute("href", nextUrl);
            setLoading(false);
          } else {
            setLoading(false);
            stop();
          }

          refreshWishlist();
        })
        .catch(function () {
          // pe eroare de retea lasam butonul ca link normal spre pagina urmatoare
          setLoading(false);
        });
    }

    // click pe buton
    wrapper.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-show-more-btn]");
      if (!btn) return;
      e.preventDefault();
      loadNext();
    });

    // infinite scroll: auto-load cand butonul se apropie de viewport
    if ("IntersectionObserver" in window) {
      observer = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) loadNext();
          }
        },
        { rootMargin: "400px 0px" }
      );
      var btn = getBtn();
      if (btn) observer.observe(btn);
    }

    // wishlist pentru produsele incarcate dinamic (iWish le leaga doar la load).
    // Delegam doar pentru itemele adaugate prin infinite scroll ([data-more-loaded]),
    // ca sa nu dublam handler-ele iWish deja legate pe itemele initiale.
    document.addEventListener("click", function (e) {
      var heart = e.target.closest(".iWishAddColl");
      if (!heart || !heart.closest("[data-more-loaded]")) return;
      e.preventDefault();
      try {
        if (typeof window.jQuery === "undefined") return;
        if (typeof window.isInWishlist !== "function") return;
        var $h = window.jQuery(heart);
        var vid = $h.attr("data-variant");
        var pid = $h.attr("data-product");
        if (window.isInWishlist(pid, vid)) {
          window.iwish_remove($h, vid, false);
          if (typeof window.iwish_add_txt_col !== "undefined") {
            $h.html(window.iwish_add_txt_col);
          }
        } else {
          window.iwish_addCollection($h, vid);
        }
        if (typeof window.iWishinit === "function") window.iWishinit();
      } catch (err) {}
      return false;
    });
  }

  if (document.readyState !== "loading") {
    init();
  } else {
    document.addEventListener("DOMContentLoaded", init);
  }
})();
